<script>
import {mapActions, mapGetters} from "vuex";
import RadioCards from "../../Content/RadioCards.vue";
import Vue from "vue";

export default {
    name: "VehicleSelectWidget",
    components: {RadioCards},

    data() {
        return {
            selectedVehicleId: null,
            selectedBodyWork: null,
            selectedFuel: null,
            selectedTransmission: null,
            eventBus: new Vue(),
        }
    },

    computed: {
        ...mapGetters([
            'getActiveVehicle',
            'getActiveVehicleWrapper',
        ]),

        bodyworkTypes() {
            return lodash.uniqBy(lodash.filter(lodash.map(this.getActiveVehicleWrapper.vehicles, 'body_work'), (item) => item !== null), 'id');
        },

        fuelTypes() {
            let filteredVehicles = lodash.filter(this.getActiveVehicleWrapper.vehicles, (vehicle) => {
                return vehicle.body_work?.id === this.selectedBodyWork;
            });

            return lodash.uniqBy(lodash.map(filteredVehicles, 'fuel'), 'id');
        },

        transmissionTypes() {
            let filteredVehicles = lodash.filter(this.getActiveVehicleWrapper.vehicles, (vehicle) => {
                return vehicle.body_work?.id === this.selectedBodyWork && vehicle.fuel?.id === this.selectedFuel;
            });

            return lodash.uniqBy(lodash.map(filteredVehicles, 'transmission'), 'id');
        },

        showBodyWorkTypes() {
            return this.bodyworkTypes.length > 1
        },

        showFuelTypes() {
            return (this.fuelTypes.length > 1) && !lodash.isNil(this.selectedBodyWork)
        },

        showTransmissionTypes() {
            return this.transmissionTypes.length > 1 && !lodash.isNil(this.selectedFuel)
        },

        selectedVehicle() {
            return lodash.find(this.getActiveVehicleWrapper.vehicles, (vehicle) => {
                return vehicle.fuel.id === this.selectedFuel && vehicle.body_work.id === this.selectedBodyWork && vehicle.transmission.id === this.selectedTransmission;
            });
        }
    },

    watch: {
        getActiveVehicleWrapper: {
            handler() {
                this.setDefaultData();
            },
            deep: true
        }
    },

    created() {
        this.setDefaultData();
    },

    methods: {
        ...mapActions([
            'changeVehicle'
        ]),

        reset() {
            this.selectedBodyWork = null;
            this.selectedFuel = null;
            this.selectedTransmission = null;
        },

        setDefaultData() {
            this.selectedVehicleId = this.getActiveVehicle.id;

            this.reset();

            if (this.bodyworkTypes.length === 1) {
                this.selectedBodyWork = lodash.first(this.bodyworkTypes)?.id;
            }

            if (this.fuelTypes.length === 1) {
                this.selectedFuel = lodash.first(this.fuelTypes)?.id;
            }

            if (this.transmissionTypes.length === 1) {
                this.selectedTransmission = lodash.first(this.transmissionTypes)?.id;
            }
        },

        handleBodyWorkInput(payload) {
            this.selectedFuel = null;
            this.selectedTransmission = null;
            this.selectedBodyWork = payload;

            this.eventBus.$emit('reset', 'fuel');
            this.eventBus.$emit('reset', 'transmission');

            if (this.fuelTypes.length === 1) {
                this.selectedFuel = lodash.first(this.fuelTypes)?.id;
            }

            if (this.transmissionTypes.length === 1) {
                this.handleTransmissionInput(lodash.first(this.transmissionTypes)?.id)
            }
        },

        handleFuelInput(payload) {
            this.selectedTransmission = null;
            this.selectedFuel = payload;

            this.eventBus.$emit('reset', 'transmission');

            if (this.transmissionTypes.length === 1) {
                this.selectedTransmission = lodash.first(this.transmissionTypes)?.id;
                this.setVehicle();
            }
        },

        handleTransmissionInput(payload) {
            this.selectedTransmission = payload;

            this.setVehicle();
        },

        setVehicle() {
            this.selectedVehicleId = this.selectedVehicle.id;
            this.changeVehicle({
                vehicleId: this.selectedVehicleId
            })
            this.$emit('vehicle-selected', this.selectedVehicleId)
        },
    }
}
</script>

<template>
    <div class="vue-vehicle-select-widget">
        <template v-if="showBodyWorkTypes">
            <h4>Type</h4>
            <RadioCards :options="bodyworkTypes" type="bodywork" :event-bus="eventBus" @input="handleBodyWorkInput" />
        </template>

        <template v-if="showFuelTypes">
            <h4>Aandrijving</h4>
            <RadioCards :options="fuelTypes" type="fuel" :event-bus="eventBus" @input="handleFuelInput" />
        </template>

        <template v-if="showTransmissionTypes">
            <h4>Transmissie</h4>
            <RadioCards :options="transmissionTypes" type="transmission" :event-bus="eventBus" @input="handleTransmissionInput" />
        </template>
    </div>
</template>
